import styled, { css } from 'styled-components'


export const devices = {
    mobile: '(max-width: 900px)',
    large: '(max-width: 1440px)',
}

export const margins = css`
    margin-top: ${({ margintop=0 }) => margintop}px;
    margin-bottom: ${({ marginbottom=0 }) => marginbottom}px;
    margin-left: ${({ marginleft=0 }) => marginleft}px;
    margin-right: ${({ marginright=0 }) => marginright}px;

    @media ${devices.mobile} {
        ${({ margintop }) => margintop && `margin-top: ${margintop / 2}px;`}
        ${({ marginbottom }) => marginbottom && `margin-bottom: ${marginbottom / 2}px;`}
    }
`

export const paddings = css`
    padding-top: ${({ paddingtop=0 }) => paddingtop}px;
    padding-bottom: ${({ paddingbottom=0 }) => paddingbottom}px;

    @media ${devices.mobile} {
        ${({ paddingtop }) => paddingtop ? `padding-top: ${paddingtop / 2}px;` : ''}
        ${({ paddingbottom }) => paddingbottom ? `padding-bottom: ${paddingbottom / 2}px;` : ''}
    }
`

export const Container = styled.section`
    margin-left: auto;
    margin-right: auto;
    max-width: ${({ maxwidth }) => maxwidth || '1400px'};
    width: 100%;
    @media (max-width: 1450px) {
        padding-left: 50px;
        padding-right: 50px;
    }
    @media ${devices.mobile} {
        padding-left: 20px;
        padding-right: 20px;
        padding-bottom: 35px;
    }
`

export const Image = styled.img`
    position: relative;
    display: block;
    vertical-align: middle;
`

const tabletWidthCss = css`
    @media ${devices.tablet} {
        width: ${({ tabletWidth=100 }) => tabletWidth}%;
    }
`

const GridColumn = styled.div`
    position: relative;
    display: inline-block;
    width: ${({ width=100 }) => width}%;
    ${({ tabletWidth }) => tabletWidth ? tabletWidthCss : ''}
    @media ${devices.mobile} {
        width: 100%;
        margin-left: 0;
        margin-right: 0;
    }
    ${margins}
`

const tabletColumnsCss = css`
    @media ${devices.tablet} {
        width: ${({ columnsTablet=1 }) => 100 / columnsTablet}%;
    }
`

export const columnsCss = css`
    & > ${GridColumn} {
        width: ${({ columns=1, totalmargin }) => totalmargin ? `calc(${100 / columns}% - ${Math.ceil(totalmargin / columns)}px)` : `${100 / columns - 2}%`};
        ${({ columnsTablet }) => columnsTablet && tabletColumnsCss}
        @media ${devices.mobile} {
            width: 100%;
        }
    }
`

export const Grid = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: stretch;
    ${props => props.width ? 'width:' + props.width + ';' : ''}
    ${margins}
    ${({ columns }) => columns ? columnsCss : ''}
`

Grid.Column = GridColumn

export const ArticleWrapColumn = styled(Grid.Column)`
    @media (min-width: 800px) {
        width: 100%;
    }
`

export const ContentWrap = styled.div`
    ${({ has_menu }) => has_menu ? `
        width: calc(100% - 220px - 60px);
    ` : ''}

    @media ${devices.mobile} {
        width: 100%;
        padding: 0 20px;
    }
`

export const Hero = styled.div`
    height: 70vh;
    max-height: 600px;
    width: 100%;
    background: center / cover no-repeat url(${props => props.background});
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
`

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    align-items: top;
    justify-content: space-between;

    ${props => props.margintop && `
        margin-top: ${props.margintop}px;
    `}

    ${props => props.marginbottom && `
        margin-bottom: ${props.marginbottom}px;
    `}

    @media ${devices.mobile} {}
`

const Button = styled.button`
    ${margins}
`

export const PrimaryButton = styled(Button)`
`

export const SecondaryButton = styled(Button)`
`
